import React from "react";

interface AlertProps {
  className?: string;
  title: string | React.ReactNode;
  description?: string | React.ReactNode;
  icon: React.ReactElement;
  variant?: "warning" | "info" | "success" | "error";
}

const Alert: React.FC<AlertProps> = ({
  className,
  title,
  description,
  icon,
  variant = "info",
}) => {
  const colorMap = {
    warning: "yellow",
    info: "blue",
    success: "green",
    error: "red",
  };
  const variantColor = `bg-${colorMap[variant]}-50 border border-${colorMap[variant]}-200`;
  const variantTextColor = `text-${colorMap[variant]}-700`;
  return (
    <div className={`${variantColor} rounded-lg p-3 ${className}`}>
      <div className="flex items-start gap-2">
        {icon &&
          React.cloneElement(
            icon as React.ReactElement<{ className: string }>,
            {
              className: `w-4 h-4 font-medium ${variantTextColor} flex-shrink-0 mt-0.5`,
            }
          )}
        <div>
          <div className={`font-medium ${variantTextColor} text-sm mb-1`}>
            {title}
          </div>
          <p className={`text-xs ${variantTextColor}`}>{description}</p>
        </div>
      </div>
    </div>
  );
};

export default Alert;
